export type AvatarFailureStage =
  | 'settings'
  | 'hub_metadata'
  | 'hub_download_url'
  | 'blob_download'
  | 'blob_validation'
  | 'vrm_parse'
  | 'webgl_context_lost'

/** 生の例外・URL・識別情報をログへ渡さないための固定値だけの診断。 */
export const reportAvatarFailure = (stage: AvatarFailureStage, status?: number, code?: string): void => {
  const safeCode =
    code &&
    /^(HUB_(AUTH_EXPIRED|RATE_LIMITED|MODEL_UNAVAILABLE|TERMS_CHANGED|SELECTION_CONFLICT|REQUEST_FAILED|INVALID_STATE|ACCOUNT_MISMATCH)|AVATAR_LOAD_FAILED|INVALID_VRM|NETWORK_ERROR|UNAUTHORIZED|REQUEST_FAILED)$/.test(
      code
    )
      ? code
      : 'REQUEST_FAILED'
  console.warn('Avatar load failed', { stage, ...(status === undefined ? {} : { status }), code: safeCode })
}

export const readAvatarFailure = (error: unknown): { status?: number; code?: string } => {
  if (typeof error !== 'object' || error === null) return {}
  const result: { status?: number; code?: string } = {}
  if (
    'status' in error &&
    typeof error.status === 'number' &&
    Number.isInteger(error.status) &&
    error.status >= 100 &&
    error.status <= 599
  ) {
    result.status = error.status
  }
  if ('code' in error && typeof error.code === 'string') result.code = error.code
  return result
}
